const reformatCartBundles = () => {
    const cartBundles = document.querySelectorAll('.cart-drawer__items .cart-items__bundle');
    cartBundles.forEach(bundle => {
        const hasMod = bundle.getAttribute('data-modded');
        // Don't try and reformat an already transformed bundle list
        if (hasMod && hasMod == "true") {
            return;
        }

        /** @type {any} */
        const bundleClone = bundle.cloneNode(true);
        const originalList = bundleClone.querySelectorAll('li');

        bundle.setAttribute('data-modded', 'true');

        const accordionContainer = document.createElement('li');
        accordionContainer.classList.add('fg-bundle-accordion');

        const accordionTitleContainer = document.createElement('div');
        accordionTitleContainer.classList.add('accordion-title')

        const accordionTitle = document.createElement('span');
        accordionTitle.textContent = "View Items";
        accordionTitle.classList.add('label')

        const accordionIcon = document.createElement('span');
        accordionIcon.classList.add('icon');
        accordionIcon.textContent = "❯";

        accordionTitleContainer.appendChild(accordionTitle);
        accordionTitleContainer.appendChild(accordionIcon);

        const accordionContentsContainer = document.createElement('li');
        accordionContentsContainer.classList.add('accordion-contents');

        const accordionContentsInner = document.createElement('ul');
        accordionContentsInner.classList.add('list-unstyled');
        accordionContentsInner.append(...originalList);
        accordionContentsContainer.append(accordionContentsInner);

        accordionTitleContainer.addEventListener('click', event => {
            /** @type {any} */
            const title = event.currentTarget;
            const parent = title.closest('.fg-bundle-accordion');
            if (parent.classList.contains('expand')) {
                parent.classList.remove('expand');
            } else {
                parent.classList.add('expand');
            }
        })

        accordionContainer.append(accordionTitleContainer, accordionContentsContainer);

        bundle.innerHTML = '';
        bundle.appendChild(accordionContainer);
    })
}

const cartObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        /**
         * The cart gets wiped out and "rehydrated" on page load which kills any sort of changes
         * we would do if we ran on DOMContentLoaded
         */
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-hydrated') {
            reformatCartBundles();
        }
        /**
         * The contents of the cart also get refreshed on any interaction with it. This will wipe out
         * any of the reformatting that has been done. This only runs when an item we modded gets the
         * data attribute stripped. (happens when morph runs on a section)
         */
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-modded') {
            if (mutation.oldValue === "true") {
                reformatCartBundles();
            }
        }

        /**
         * When items are added or removed from the cart, reformat needs to run as the number of rows
         * in the cart table is changing.
         */
        if (mutation.type === 'childList') {
            for (let ii = 0; ii < mutation.addedNodes.length; ii++) {
                /** @type {any} */
                const addedNode = mutation.addedNodes[ii];
                /** @type {any} */
                const removedNode = mutation.removedNodes[ii];
                if (addedNode && addedNode.className && addedNode.classList.contains('cart-drawer__content')) {
                    reformatCartBundles();
                    break;
                }
                if (addedNode && addedNode.className && addedNode.classList.contains('cart-items__table-row')) {
                    reformatCartBundles();
                    break;
                }
                if (removedNode && removedNode.className && removedNode.classList.contains('cart-items__table-row')) {
                    reformatCartBundles();
                    break;
                }
            }
        }
    })
})

const cartObservable = document.querySelector('#header-group header');

if (cartObservable) {
    cartObserver.observe(cartObservable, { childList: true, attributes: true, subtree: true, attributeOldValue: true });
}
